import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'CategoryContentSettings',
  data () {
    return {
      prompt: '',
      isLoading: {
        page: false,
        saving: false
      }
    }
  },
  computed: {
    ...mapGetters([
      'activeContentplan'
    ]),
    workspaceId () {
      return parseInt(this.$route.params.workspaceId)
    },
    contentplanId () {
      return parseInt(this.$route.params.contentplanId)
    },
    contentplanName () {
      return this.activeContentplan?.name || `#${this.contentplanId}`
    },
    isEligible () {
      return this.activeContentplan?.main_cms_integration === 'wordpress' && this.activeContentplan?.type === 'ecommerce'
    }
  },
  watch: {
    isEligible (newVal, oldVal) {
      if (newVal && !oldVal) this.loadSettings()
    }
  },
  async mounted () {
    if (this.isEligible) await this.loadSettings()
  },
  methods: {
    ...mapActions([
      'categoryContentSettingsGet',
      'categoryContentSettingsPut'
    ]),
    ...mapMutations([
      'setSnackbar'
    ]),
    async loadSettings () {
      this.isLoading.page = true
      try {
        const settings = await this.categoryContentSettingsGet({ contentplanId: this.contentplanId })
        this.prompt = settings?.prompt || ''
      } catch (error) {
        this.setSnackbar({ open: true, text: this.getErrorMessage(error, 'Failed to load category content settings'), type: 'error' })
      } finally {
        this.isLoading.page = false
      }
    },
    async saveSettings () {
      this.isLoading.saving = true
      try {
        const settings = await this.categoryContentSettingsPut({
          contentplanId: this.contentplanId,
          prompt: this.prompt
        })
        this.prompt = settings?.prompt || ''
        this.setSnackbar({ open: true, text: 'Category content settings saved', type: 'success' })
      } catch (error) {
        this.setSnackbar({ open: true, text: this.getErrorMessage(error, 'Failed to save category content settings'), type: 'error' })
      } finally {
        this.isLoading.saving = false
      }
    },
    getErrorMessage (error, defaultMessage) {
      if (error?.response?.data?.message) return error.response.data.message
      if (error?.response?.data?.error) return error.response.data.error
      if (error?.message) return error.message
      if (typeof error === 'string') return error
      return defaultMessage
    }
  }
}
